import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

// Utils.
import { gaEventIfAllowed } from '../../utils/googleAnalytics';
import Button from '../Common/Button';

const Register: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <>
      <h1>{t('common:register.registerWelcome')}</h1>
      <h4>{t('common:register.newUserQuestion')}</h4>
      <div className="newUserDetails content">
        <p className="intro">{t('common:register.registerMessage')}</p>
        <p>{t('common:register.registerDescription')}</p>
        <Button
          link={`${import.meta.env.VITE_URL_REGISTER_USER}`}
          onClick={(): void => {
            gaEventIfAllowed({
              category: 'Rekisteröidy',
              action: 'Rekisteröidy yksityishenkilönä',
            });
          }}
        >
          {t('common:register.registerAs')}
        </Button>
        <p>
          <Trans
            i18nKey="common:register.registerDescriptionNoStrong"
            values={{ customerService: t(`common:register.registerDescriptionNoStrongCustomerServiceLink`) }}
          >
            .
            <a
              href={import.meta.env.VITE_URL_REGISTER_USER_NO_STRONG}
              onClick={(): void => {
                gaEventIfAllowed({
                  category: 'Rekisteröidy',
                  action: 'Rekisteröidy ilman vahvaa',
                });
              }}
            ></a>
          </Trans>
        </p>
      </div>
    </>
  );
};

export default Register;
